const clientCode = () => {
  const pathname = window.location.pathname
  const parts = pathname.split('/').filter(part => part !== '') // Elimina partes vacías

  // Si tiene el formato /tienda/:client
  if (parts[0] === 'tienda' && parts[1]) {
    return parts[1]
  }

  // Si tiene el formato /:client (la primera parte es el cliente)
  if (parts[0] && parts[0] !== 'tiendas' && parts[0] !== 'sucursales' && parts[0] !== 'checkout') {
    return parts[0]
  }

  // Fallback: intentar con el método anterior
  const url = window.location.href.split('?')[0]
  return url.split('/')[4]
}

export default clientCode
